import gql from 'graphql-tag';
import Order from '../../../entity/order';

const getOrder = gql`
  query orderByStore{
    orderByStore {
      ${Order.fragmentsFields()}
    }
  }
`;

export default getOrder;
